export const FIXED_DT = 1 / 120
const MAX_ACCUMULATED_TIME = 0.1
const EPSILON = 1e-10

export class FixedStepRunner {
  private accumulator = 0
  private readonly step: (fixedDeltaSeconds: number) => void

  public constructor(step: (fixedDeltaSeconds: number) => void) {
    this.step = step
  }

  public get alpha(): number {
    return this.accumulator / FIXED_DT
  }

  public advance(frameDeltaSeconds: number): void {
    const safeDelta = Number.isFinite(frameDeltaSeconds) ? Math.max(0, frameDeltaSeconds) : 0
    this.accumulator = Math.min(this.accumulator + safeDelta, MAX_ACCUMULATED_TIME)
    while (this.accumulator + EPSILON >= FIXED_DT) {
      this.step(FIXED_DT)
      this.accumulator -= FIXED_DT
    }
    if (this.accumulator < 0) this.accumulator = 0
  }

  public reset(): void {
    this.accumulator = 0
  }
}
